import { JSX, useState, useEffect } from 'react'

import { AbsoluteCenter, Spinner } from '@chakra-ui/react'

import { Throttle } from '@/lib/alchemy.js'

import * as scope_model from '@/model/scope.js'

import * as token_storage from '@/storage/token.js'




export enum State
{
	loading,

	manager,
	supervisor,

	authorize,

}


export async function retrieve (): Promise<State>
{
	try
	{
		let doc = await token_storage.retrieve()

		if (doc.is_super === false)
		{
			return State.authorize

		}

		if (doc.mode > scope_model.Mode.普通)
		{
			return State.supervisor

		}

		return State.manager

	}

	catch (e)
	{
		// console.error(e)

	}

	return State.authorize

}


export default function
(
	props: {
		dispatch(): Promise<void>

		authorize(dispatch: (expire: Date) => void): JSX.Element

		manager   : JSX.Element
		supervisor: JSX.Element

	},

)
:	JSX.Element
{
	let [state, update_state] = useState<State>(State.loading)

	useEffect(
		Throttle.once(
			async () =>
			{
				let v = await retrieve()

				if (v === State.authorize)
				{
					await props.dispatch()

				}

				update_state(v)

			},

			{ void: true },

		),

		[],

	)

	if (state === State.manager)
	{
		return (
			<>{props.manager}</>

		)

	}

	if (state === State.supervisor)
	{
		return (
			<>{props.supervisor}</>

		)

	}

	if (state === State.authorize)
	{
		let dispatch_ = (expire: Date): void =>
		{
			let timer = setInterval(
				async (): Promise<void> =>
				{
					if (new Date() >= expire)
					{
						clearInterval(timer)

						return

					}

					let v = await retrieve()

					if (v === State.authorize)
					{
						return

					}

					update_state(v)

					clearInterval(timer)

				},

				3000,

			)


		}

		return (
			<>{props.authorize(Throttle.once(dispatch_) ) }</>

		)

	}

	return (
		<AbsoluteCenter>
			<Spinner />

		</AbsoluteCenter>

	)




}
